module.exports = __webpack_public_path__ + "files/ce81936d829c1ac530749ba2fe913de0.png";